import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_auto" }, { title: "menu_sidebar_auto_orders", link: "/auto/orders" }];

const AutoOrderListing = Loadable({
  loader: () => import("container/auto/order/listing"),
  loading() {
    return <Loader />;
  }
});

const AutoOrder = Loadable({
  loader: () => import("container/auto/order"),
  loading() {
    return <Loader />;
  }
});

export const autoOrderRoutes: IRoute[] = [
  {
    path: "/auto/orders",
    element: <AutoOrderListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/auto/orders/details/:id?",
    element: <AutoOrder />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
